import { render, staticRenderFns } from "./OrderBasicChart.vue?vue&type=template&id=027fc5f1&scoped=true&"
import script from "./OrderBasicChart.vue?vue&type=script&lang=js&"
export * from "./OrderBasicChart.vue?vue&type=script&lang=js&"
import style0 from "./OrderBasicChart.vue?vue&type=style&index=0&id=027fc5f1&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027fc5f1",
  null
  
)

export default component.exports